// ── A function problem's workspace, read once (`EX-FNC05`) ──────────────────
// The practice page and the contest problem page both draw a function problem
// the same way: the five languages only, the editor on each language's
// starter, the run panel by parameter and the compiler read at the student's
// own file. This is the one place that decides a view is such a problem.

import {
  isFunctionLanguage,
  type FunctionSignature,
  type FunctionStarters,
} from "../../lib/function-signature";

export type FunctionWorkspace = {
  signature: FunctionSignature;
  starters: FunctionStarters;
  /** The runtime catalogue's language is one this problem's grader is written in. */
  offers: (languageKey: string) => boolean;
  /** What the editor opens on in `languageKey`; empty for a language the problem does not offer. */
  starter: (languageKey: string) => string;
};

/** `null` on a whole program (no signature), which keeps every screen as it was. */
export function functionWorkspace(
  view: { signature?: FunctionSignature | null; starters?: FunctionStarters | null } | null | undefined,
): FunctionWorkspace | null {
  const signature = view?.signature;
  const starters = view?.starters;
  if (!signature || !starters) return null;
  return {
    signature,
    starters,
    offers: isFunctionLanguage,
    starter: (languageKey) => (isFunctionLanguage(languageKey) ? starters[languageKey] : ""),
  };
}
